import { createContext } from "react"

const EditorContext = createContext()

export default EditorContext
